The input parameter for the `applyWithSeekButton` query.
